<template>
    <div class="overflow-auto">
        <item
            v-for="item in sendLists"
            :key="item.id"
            :send-list="item"
            :isCurrent="isCurrent(item)"
            @select="onSelect"
            @quick-message="onSendQuickMessage"
            @email-message="(e) => $emit('email-message', e)"
            @edit="onEdit"
            @delete="onDelete"
        ></item>
        <infinite-loading @infinite="loadSendLists" spinner="waveDots" :distance="600" :identifier="infiniteLoadKey">
            <span slot="no-more"></span>
            <template slot="no-results">
                <h5><span class="badge badge-secondary">No results</span></h5>
            </template>
            <template slot="error" slot-scope="{ trigger }">
                <h5><span class="badge badge-danger">Whoops. It looks like the server is unavailable.</span>
                </h5>
                <div class="text-center">
                    <el-button size="mini" @click="trigger()">Retry</el-button>
                </div>
            </template>
        </infinite-loading>
    </div>
</template>

<script>
  import Item from './list-item';
  import {addQueryParams} from "../../libs/url";
  import eventBus from "../../event-bus";

  export default {
    props: {
      url: String,
    },

    data() {
      return {
        sendLists: [],
        cancelToken: null,
        isRequestActive: false,
        current: null,
        page: 1,
        infiniteLoadKey: moment().format('x'),
      };
    },

    computed: {},

    watch: {
      sendLists(value) {
        this.current = _.find(value, {id: _.get(this.current, 'id', null)}, null);
      },

      url(newUrl) {
        this.refresh();
      },

      current(newValue) {
        this.$emit('select', newValue);
      },

      isRequestActive(newValue) {
        if (newValue) {
          this.$emit('refresh-start');
        } else {
          this.$emit('refresh-finish');
        }
      },
    },

    methods: {
      /**
       * @param {Object} $state
       * @return {undefined}
       */
      loadSendLists($state) {
        this.performLoading($state);
      },

      /**
       * @param {Object|null} $state
       * @return {undefined}
       */
      performLoading($state = null) {
        if (this.isRequestActive) {
          this.cancelToken.cancel();
        } else {
          this.isRequestActive = true;
        }

        this.cancelToken = axios.CancelToken.source();

        axios.get(addQueryParams(this.url, {page: this.page}), {
          cancelToken: this.cancelToken.token
        })
          .then(data => this.onLoadSuccess(data, $state))
          .catch(error => this.onLoadError(error, $state))
          .then((isCancelled) => {
            if (!isCancelled) {
              this.isRequestActive = false;
            }
          });
      },

      /**
       * @param {Object} data
       * @param {Object} $state
       * @return {Boolean}
       */
      onLoadSuccess({data: {data: items, meta:{current_page, last_page}}}, $state) {
        if (_.size(items)) {
          this.sendLists.push(...items);
          $state && $state.loaded();
        }

        if (current_page < last_page) {
          this.page++;
        } else {
          $state && $state.complete();
        }

        return false;
      },

      /**
       * @param {Object} error
       * @param {Object} $state
       * @return {Boolean}
       */
      onLoadError(error, $state) {
        if (axios.isCancel(error)) {
          return true;
        }
        $state && $state.error();

        return false;
      },

      /**
       * @param {Object} item
       */
      onSelect(item) {
        this.current = item;
      },

      /**
       * @event quick-message
       * @param {Object} item
       */
      onSendQuickMessage(item) {
        this.$emit('quick-message', item);
      },

      /**
       * @event edit
       * @param {Object} item
       */
      onEdit(item) {
        this.$emit('edit', item);
      },

      /**
       * @event delete
       * @param {Object} item
       */
      onDelete(item) {
        this.$emit('delete', item);
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.sendLists = [];
        this.page = 1;
        this.infiniteLoadKey = moment().format('x');
      },

      /**
       * @param {Object} item
       * @return {Boolean}
       */
      isCurrent(item) {
        return item.id === _.get(this.current, 'id');
      },

      /**
       * @param {Number} id
       */
      removeItemById(id) {
        const index = _.findIndex(this.sendLists, {id: id});
        if (index < 0) {
          return;
        }

        this.sendLists.splice(index, 1);
      },

      /**
       * @param {Object} model
       * @param {Number} sendListId
       */
      onNoteStored({model, sendListId}) {
        _.each(this.sendLists || [], (sendList, index) => {
          if (_.get(sendList, 'id') !== sendListId) {
            return;
          }

          this.$set(this.sendLists[index], 'note', model);
        });
      },
    },

    created() {
      eventBus.$on('send-list-note-stored', this.onNoteStored);
    },

    beforeDestroy() {
      eventBus.$off('send-list-note-stored', this.onNoteStored);
    },

    components: {
      Item,
    }
  }
</script>
